import { Text, Box, Link} from "@chakra-ui/layout";

function Footer() {
  return (
    <footer>
      <Box w="100%" p="5" bg="teal.500">
        <Text textAlign="center" color="white">
          Crafted with ❤️ by <Link target="_blank" fontWeight="semibold" href="https://zagi.live/"> Zagi</Link>
        </Text>
      </Box>
    </footer>
  );
}

export default Footer;
